export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9831.33201994.jpg";